import React from 'react';
import {
  AnalysisSpecComp,
  BasicInfoComp,
  PerformanceComparison,
  PositionAnalysis,
  RiskAssessmentComparison
} from '../ProductComparisonTab/index';
import { ScrollArea } from '@/components/ui/scroll-area';
import ActionBar from '@/components/ActionBar';
import { useState } from 'react';
import { SkeletonDashboard } from '@/components/loading/Skeleton';

const ProductComparison: React.FC<{ totalData: any; loading: boolean }> = ({
  totalData,
  loading
}) => {
  console.log('totalData', totalData);
  console.log('loading', loading);
  const [selectAll, setSelectAll] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const handleSelectAll = (value: boolean) => {
    setSelectAll(value);
    setIsIndeterminate(false);
  };

  if (loading) {
    return (
      <div className="absolute left-0 top-0 z-[111111] flex h-full w-full items-center justify-center">
        <SkeletonDashboard className="absolute left-0 top-0 w-full px-0" />
      </div>
    );
  }

  return (
    <>
      <ScrollArea className="scroll-area-block h-full w-full">
        {/* 基金产品深度 对比分析专业对比 */}
        <AnalysisSpecComp totalData={totalData} />
        {/* 基础信息对比 */}
        <BasicInfoComp totalData={totalData} />
        {/* 收益表现对比 */}
        <PerformanceComparison totalData={totalData} />
        {/* 风险评估对比 */}
        <RiskAssessmentComparison totalData={totalData} />
        {/* 持仓穿透分析 */}
        <PositionAnalysis totalData={totalData} />
      </ScrollArea>
      {/* 操作栏 */}
      <ActionBar
        selectAll={selectAll}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
        className="px-0"
      />
    </>
  );
};

export default ProductComparison;
